module.exports = __webpack_public_path__ + "img/addProjectCover.a981790c.svg";